import { useContext } from "react";
import {
  AiOutlineLinkedin as LightLinkedin,
  AiFillLinkedin as DarkLinkedin,
  AiFillGithub as LightGithub,
  AiOutlineGithub as DarkGithub,
  AiFillMail as DarkMail,
  AiOutlineMail as LightMail,
} from "react-icons/ai";
import {
  RiTwitterLine as LightTwitter,
  RiTwitterFill as DarkTwitter,
} from "react-icons/ri";
import { ScrollContext } from "../../Context/ScrollContext";
import { ThemeContext } from "../../Context/ThemeContext";

const Contact = () => {
  const { theme } = useContext(ThemeContext);

  const { ContactRef } = useContext(ScrollContext);

  return (
    <div id="contact" className="main-content-div" ref={ContactRef}>
      <h1>Contact</h1>
      <div className="contact-div">
        <a
          href={"https://www.linkedin.com/in/david-guillaumant-mergler/"}
          target="_blank"
          rel="noreferrer"
        >
          {theme ? (
            <>
              <DarkLinkedin />
              <span> David Guillaumant-Mergler</span>
            </>
          ) : (
            <>
              <DarkLinkedin />
              <span> David Guillaumant-Mergler</span>
            </>
          )}
        </a>
        <a
          href={"https://github.com/visionspider"}
          target="_blank"
          rel="noreferrer"
        >
          {theme ? (
            <>
              <LightGithub /> <span> @visionspider</span>
            </>
          ) : (
            <>
              <LightGithub /> <span> @visionspider</span>
            </>
          )}
        </a>
        <a
          href={"https://twitter.com/DavieGie"}
          target="_blank"
          rel="noreferrer"
        >
          {theme ? (
            <>
              <DarkTwitter /> <span> @DavieGie</span>
            </>
          ) : (
            <>
              <DarkTwitter /> <span> @DavieGie</span>
            </>
          )}
        </a>
        <a
          href={"mailto: d.guillaumant.m@hotmail.com"}
          target="_blank"
          rel="noreferrer"
        >
          {theme ? (
            <>
              <DarkMail /> <span> d.guillaumant.m@hotmail.com</span>
            </>
          ) : (
            <>
              <DarkMail /> <span> d.guillaumant.m@hotmail.com</span>
            </>
          )}
        </a>
      </div>
    </div>
  );
};

export default Contact;
